export default function externalLinks () {
  const anchors = document.querySelectorAll('a')
  anchors.forEach(anchor => {
    if (anchor.href.match('^(mailto:|tel:).*') === false && anchor.hostname !== window.location.hostname) {
      anchor.setAttribute('target', '_blank')
    }
  })
}
